import React from 'react';
import FormButton from "../Components/Buttons/FormButton";


type PickedLayout = {
    handleClose: () => void;
};

const PickedLayout: React.FC<PickedLayout> = ({ handleClose }) => {
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        handleClose();
    };

    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="px-2">
                    <label className="w-100 text-center fs-16 mb-2">This order is partially picked due to (missing quantity 01 of item1254789 )</label>
                </div>
            </div>

            <div className="d-flex justify-content-end mt-4 gap-2">
                <FormButton
                    tabIndex={25}
                    className="sph-btn me-4"
                    handleClick={() => handleClose()}>
                    Close
                </FormButton>
            </div>
        </>
    );
};

export default PickedLayout;
